var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "template-generator-component" },
    [
      !_vm.showTemplateGenerator
        ? _c("FileManagerComponent", {
            ref: "fileManager",
            attrs: {
              height: "650",
              basePath: _vm.basePath,
              rootBasePath: _vm.path,
              idEntityTypeBase: _vm.idEntityTypeBase,
              context: _vm.context,
              mainFolderDescription: _vm.mainFolder,
              canDropFilesOnMainFolder: false,
              canCreateFoldersOnMainFolder: false,
              mode: _vm.fileManagerMode,
              initialBasePath: _vm.initialBasePath,
              initialPath: _vm.initialPath,
            },
          })
        : _vm._e(),
      _vm.loadingData
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _vm._e(),
      [
        _c("PromptDialogComponent", {
          staticClass: "dialog-form",
          attrs: {
            title: _vm.texts.saveTemplateAs,
            isOpened: _vm.openedSaveAsDialog,
            formSchema: _vm.saveAsDialogFormSchema,
            context: _vm.context,
            formFieldValues: _vm.formFieldValues,
          },
          on: { "execute-action": _vm.executeDialogAction },
        }),
        _c(
          "section",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTemplateGenerator,
                expression: "showTemplateGenerator",
              },
            ],
            staticClass: "template-generator-container",
          },
          [
            _c(
              "section",
              { staticClass: "header-toolbar" },
              [
                _vm.template
                  ? _c("aside", { staticClass: "header-info-container" }, [
                      _c("h1", { staticClass: "header-title" }, [
                        _vm._v(_vm._s(_vm.template.name)),
                      ]),
                      _c("p", { staticClass: "header-description" }, [
                        _vm._v(_vm._s(_vm.template.description)),
                      ]),
                    ])
                  : _vm._e(),
                _c("v-spacer"),
                _c("LfActionsBarComponent", {
                  staticClass: "action-buttons",
                  attrs: { buttons: _vm.buttons },
                  on: { "execute-action": _vm.executeAction },
                }),
              ],
              1
            ),
            _c(
              "main",
              { staticClass: "main-area" },
              [
                _c(
                  "section",
                  { staticClass: "tree-view-container" },
                  [
                    _c("div", { staticClass: "tree-view-title" }, [
                      _vm._v(_vm._s(_vm.texts.selectFields)),
                    ]),
                    _c("ejs-treeview", {
                      staticClass: "tree-view",
                      attrs: {
                        fields: _vm.treeviewFields,
                        nodeSelected: _vm.onTreeViewNodeSelected,
                      },
                    }),
                  ],
                  1
                ),
                _c("ejs-documenteditorcontainer", {
                  ref: "documentEditor",
                  staticClass: "document-editor",
                  attrs: {
                    enableToolbar: true,
                    height: _vm.documentEditorHeight,
                    toolbarItems: _vm.toolbarItems,
                    toolbarClick: _vm.onToolbarClick,
                    enableComment: false,
                    serviceUrl: _vm.serviceUrl,
                    contentChange: _vm.onContentChange,
                    documentChange: _vm.onDocumentChange,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }